import React, { useState, useEffect, useContext } from 'react';
import { ArrowDownOnSquareIcon, ClockIcon, MoonIcon, SunIcon } from '@heroicons/react/20/solid';
// import ClockInData from './clockindata';
// import Modal from './modal';
import { useNavigate } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import { set } from 'lodash';
import LoadingComponent from './loading';
import { AuthContext } from "../AuthContext";

export default function StaffActions() {
  const [staffList, setStaffList] = useState([]);
  const [clock, setClock] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [error, setError] = useState(null);
  const [staff, setStaff] = useState([]);

  const user = useContext(AuthContext);

  // current user

  const currentId = user?.id;


  const navigate = useNavigate();

  const token = localStorage.getItem('token');

  const fetchStaff = async () => {
    try {
      // Fetch staff data
      const staffResponse = await fetch('https://api.insightos.co.uk/api/staff', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials : 'include',

      });

      const staffData = await staffResponse.json();

      if (!staffResponse.ok) {
        throw new Error(staffData.message || 'Failed to fetch staff data.');
      }

      const staff = staffData.data;

      // Fetch clock-in data
      const clockInResponse = await fetch('https://api.insightos.co.uk/api/clockin', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials : 'include',

      });

      const clockInData = await clockInResponse.json();

      if (!clockInResponse.ok) {
        throw new Error(clockInData.message || 'Failed to fetch clock-in data.');
      }

      const clockInDataAll = clockInData.data;

      // Debug logging
      console.log('ClockIn Data:', clockInDataAll);

      // Process and merge data
      const staffWithClockInStatus = staff.map((staffMember) => {
        const id = staffMember.id;
        const today = format(new Date(), 'yyyy-MM-dd'); // Format the date to 'YYYY-MM-DD'

        const clockInDataForUser = clockInDataAll.find(
          (c) => {
            // Convert ISO date to comparable format
            const clockInDate = parseISO(c.Date);
            const clockInDateFormatted = format(clockInDate, 'yyyy-MM-dd');
            
            return c.StaffId === id && clockInDateFormatted === today;
          }
        );

        // Debug logging
        console.log(`Staff Member: ${staffMember.Name}`);
        console.log(`ClockInDataForUser:`, clockInDataForUser);

        return {
          ...staffMember,
          isClockedIn: clockInDataForUser ? clockInDataForUser.ClockedIn === 1 && clockInDataForUser.ClockedOut === 0 : false,
          isOnBreak: clockInDataForUser ? clockInDataForUser.Break === 1 : false,
          clockInTime: clockInDataForUser ? clockInDataForUser.ClockIn : null, // Add ClockIn field here
        };
      });

      // Debug logging
      console.log('Staff with Clock-In Status:', staffWithClockInStatus);

      setStaffList(staffWithClockInStatus);
    } catch (error) {
      console.error('Error fetching staff data:', error);
    }
  };

  useEffect(() => {
    fetchStaff();
  }, [reload]);


      const fetchClockIns = async () => {
        try {
          const clockIns = await fetch('https://api.insightos.co.uk/api/clockins', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json',
             },
              credentials : 'include',
          });
  
          if (!clockIns.ok) throw new Error('Failed to fetch clock ins');
          const data = await clockIns.json();
          setStaff(data.data);
        } catch (error) {
          console.error('Failed to fetch clock ins:', error);
        }
      };



      useEffect(() => {
  
      fetchClockIns(); // Initial fetch
      
    }, []);

  

  console.log('Staff List:', staffList);


  const handleClockInOut = async (staff) => {
  setIsLoading(true);
  const id = staff.id;
  const now = new Date();
  const timeOnly = format(now, 'HH:mm:ss');
  const dateOnly = format(now, 'yyyy-MM-dd');
  let success = false;

  try {
    const getGeoTag = () =>
      new Promise((resolve) => {
        if (window.electron && window.electron.GeoAPI) {
          window.electron.GeoAPI.getLocation()
            .then((geoTag) => resolve(geoTag))
            .catch(() => resolve('Unknown'));
        } else if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              resolve(`${latitude},${longitude}`);
            },
            () => resolve('Unknown')
          );
        } else {
          resolve('Unknown');
        }
      });

    const geoTag = await getGeoTag();

    const clockInResponse = await fetch('https://api.insightos.co.uk/api/clockin', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });

    if (!clockInResponse.ok) {
      const err = await clockInResponse.json().catch(() => ({}));
      throw new Error(err.message || 'Failed to fetch clock-in records');
    }

    const clockInData = await clockInResponse.json();
    const clockInDataAll = clockInData.data;

    const clockInDataFiltered = clockInDataAll.find((c) => {
      const clockInDate = parseISO(c.Date);
      const clockInDateFormatted = format(clockInDate, 'yyyy-MM-dd');
      return c.StaffId === id && clockInDateFormatted === dateOnly;
    });

    if (clockInDataFiltered && clockInDataFiltered.ClockedIn === 1 && clockInDataFiltered.ClockedOut === 0) {
      const clockInTime = new Date(`${dateOnly}T${clockInDataFiltered.ClockIn}`);
      const clockOutTime = now;
      const shiftLengthInMinutes = (clockOutTime - clockInTime) / 60000;
      const totalPay = shiftLengthInMinutes * (staff.HourlyRate / 60);

      const putRes = await fetch(`https://api.insightos.co.uk/api/clockin/addput/${clockInDataFiltered.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          ClockOut: timeOnly,
          ClockedOut: 1,
          ClockedIn: 0,
          HoursWorked: parseFloat(shiftLengthInMinutes) / 60,
          TotalPay: parseFloat(totalPay),
          GeoTag: geoTag,
        }),
      });

      const putJson = await putRes.json().catch(() => ({}));
      if (!putRes.ok) throw new Error(putJson.message || 'Failed to update clock-out');

      console.log(`${staff.Name} clocked out with GeoTag: ${geoTag}`);
      success = true;
    } else {
      const todaysshiftResponse = await fetch('https://api.insightos.co.uk/api/todaysshift', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });

      if (!todaysshiftResponse.ok) {
        const err = await todaysshiftResponse.json().catch(() => ({}));
        throw new Error(err.message || 'Failed to fetch todayshift data.');
      }

      const todaysshiftData = await todaysshiftResponse.json();
      const todaysshift = todaysshiftData.data;

      const shift = todaysshift.find((shift) => shift.StaffId === id);
      if (!shift) throw new Error('No shift found for the staff member.');

      const shiftStartTime = shift.StartTime;
      const late = shiftStartTime < timeOnly ? 1 : 0;

      const postRes = await fetch('https://api.insightos.co.uk/api/clockin/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          ClockIn: timeOnly,
          ClockedIn: 1,
          ClockedOut: 0,
          HourlyRate: staff.HourlyRate,
          StaffId: staff.id,
          Date: dateOnly,
          Department: staff.Role,
          StaffName: staff.Name,
          Late: late,
          GeoTag: geoTag,
        }),
      });

      const postJson = await postRes.json().catch(() => ({}));
      if (!postRes.ok) throw new Error(postJson.message || 'Failed to create clock-in');

      console.log(`${staff.Name} clocked in with GeoTag: ${geoTag}`);
      success = true;
    }
  } catch (error) {
    console.error('Error handling clock in/out:', error);
    setError(error.message || 'No Shift Found For This Staff Member, Cannot Clock In');
  } finally {
    setIsLoading(false);
    if (success) setReload((prev) => !prev);
  }
};



  

const handleBreakStartEnd = async (staff) => {
  setIsLoading(true);
  const id = staff.id;
  const now = new Date();
  const timeOnly = format(now, 'HH:mm:ss');
  const dateOnly = format(now, 'yyyy-MM-dd');
  let success = false;

  try {
    const getGeoTag = () =>
      new Promise((resolve) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              resolve(`${latitude},${longitude}`);
            },
            () => resolve('Unknown')
          );
        } else {
          resolve('Unknown');
        }
      });

    const geoTag = await getGeoTag();

    const clockInResponse = await fetch('https://api.insightos.co.uk/api/clockin', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });

    if (!clockInResponse.ok) {
      const err = await clockInResponse.json().catch(() => ({}));
      throw new Error(err.message || 'Failed to fetch clock-in records');
    }

    const clockInData = await clockInResponse.json();
    const clockInDataAll = clockInData.data;

    const clockInDataFiltered = clockInDataAll.filter((c) => {
      const clockInDate = parseISO(c.Date);
      const clockInDateFormatted = format(clockInDate, 'yyyy-MM-dd');
      return c.StaffId === id && clockInDateFormatted === dateOnly;
    });

    if (clockInDataFiltered.length > 0 && clockInDataFiltered[0].Break === 1) {
      const breakStart = new Date(`${dateOnly}T${clockInDataFiltered[0].BreakStart}`);
      const breakEnd = now;
      const breakLength = (breakEnd - breakStart) / 60000;

      const putRes = await fetch(`https://api.insightos.co.uk/api/clockin/breakend/${clockInDataFiltered[0].id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          BreakEnd: timeOnly,
          Break: 0,
          StaffBreak: parseFloat(breakLength),
          GeoTag: geoTag,
        }),
      });

      const putJson = await putRes.json().catch(() => ({}));
      if (!putRes.ok) throw new Error(putJson.message || 'Failed to end break');

      console.log(`${staff.Name} ended break with GeoTag: ${geoTag}`);
      success = true;
    } else if (clockInDataFiltered.length > 0) {
      const putRes = await fetch(`https://api.insightos.co.uk/api/clockin/breakstart/${clockInDataFiltered[0].id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          BreakStart: timeOnly,
          Break: 1,
          GeoTag: geoTag,
        }),
      });

      const putJson = await putRes.json().catch(() => ({}));
      if (!putRes.ok) throw new Error(putJson.message || 'Failed to start break');

      console.log(`${staff.Name} started break with GeoTag: ${geoTag}`);
      success = true;
    } else {
      console.log('No clock-in record found for today.');
      setError('No clock-in record found for today.');
    }
  } catch (error) {
    console.error('Error handling break start/end:', error);
    setError(error.message || 'Error handling break start/end');
  } finally {
    setIsLoading(false);
    if (success) setReload((prev) => !prev);
  }
};

// HANDLERS FOR ACTING ON OTHER USERS (do not call the same endpoints as current user actions)
const handleClockInOutOther = async (otherStaff) => {
  setIsLoading(true);
  const id = otherStaff.id;
  const now = new Date();
  const timeOnly = format(now, 'HH:mm:ss');
  const dateOnly = format(now, 'yyyy-MM-dd');
  let success = false;

  try {
    const getGeoTag = () =>
      new Promise((resolve) => {
        if (window.electron && window.electron.GeoAPI) {
          window.electron.GeoAPI.getLocation()
            .then((geoTag) => resolve(geoTag))
            .catch(() => resolve('Unknown'));
        } else if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              resolve(`${latitude},${longitude}`);
            },
            () => resolve('Unknown')
          );
        } else {
          resolve('Unknown');
        }
      });

    const geoTag = await getGeoTag();

    const clockInResponse = await fetch('https://api.insightos.co.uk/api/clockin', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });

    if (!clockInResponse.ok) {
      const err = await clockInResponse.json().catch(() => ({}));
      throw new Error(err.message || 'Failed to fetch clock-in records');
    }

    const clockInData = await clockInResponse.json();
    const clockInDataAll = clockInData.data;

    const clockInDataFiltered = clockInDataAll.find((c) => {
      const clockInDate = parseISO(c.Date);
      const clockInDateFormatted = format(clockInDate, 'yyyy-MM-dd');
      return c.StaffId === id && clockInDateFormatted === dateOnly;
    });

    if (clockInDataFiltered && clockInDataFiltered.ClockedIn === 1 && clockInDataFiltered.ClockedOut === 0) {
      const clockInTime = new Date(`${dateOnly}T${clockInDataFiltered.ClockIn}`);
      const clockOutTime = now;
      const shiftLengthInMinutes = (clockOutTime - clockInTime) / 60000;
      const totalPay = shiftLengthInMinutes * (otherStaff.HourlyRate / 60);

      const putRes = await fetch(`https://api.insightos.co.uk/api/clockin/staffend/${clockInDataFiltered.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          ClockOut: timeOnly,
          ClockedOut: 1,
          ClockedIn: 0,
          HoursWorked: parseFloat(shiftLengthInMinutes) / 60,
          TotalPay: parseFloat(totalPay),
          GeoTag: geoTag,
        }),
      });

      const putJson = await putRes.json().catch(() => ({}));
      if (!putRes.ok) throw new Error(putJson.message || 'Failed to clock out other user');

      console.log(`${otherStaff.Name} clocked out with GeoTag: ${geoTag}`);
      success = true;
    } else {
      const todaysshiftResponse = await fetch('https://api.insightos.co.uk/api/todaysshift', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });

      if (!todaysshiftResponse.ok) {
        const err = await todaysshiftResponse.json().catch(() => ({}));
        throw new Error(err.message || 'Failed to fetch todayshift data.');
      }

      const todaysshiftData = await todaysshiftResponse.json();
      const todaysshift = todaysshiftData.data;
      const shift = todaysshift.find((shift) => shift.StaffId === id);

      if (!shift) throw new Error('No shift found for the staff member.');

      const shiftStartTime = shift.StartTime;
      const late = shiftStartTime < timeOnly ? 1 : 0;

      const postRes = await fetch('https://api.insightos.co.uk/api/clockin/staffstart', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          ClockIn: timeOnly,
          ClockedIn: 1,
          ClockedOut: 0,
          HourlyRate: otherStaff.HourlyRate,
          StaffId: otherStaff.id,
          Date: dateOnly,
          Department: otherStaff.Role,
          StaffName: otherStaff.Name,
          Late: late,
          GeoTag: geoTag,
        }),
      });

      const postJson = await postRes.json().catch(() => ({}));
      if (!postRes.ok) throw new Error(postJson.message || 'Failed to clock in other user');

      console.log(`${otherStaff.Name} clocked in with GeoTag: ${geoTag}`);
      success = true;
    }
  } catch (error) {
    console.error('Error handling clock in/out for other user:', error);
    setError(error.message || 'No Shift Found For This Staff Member, Cannot Clock In');
  } finally {
    setIsLoading(false);
    if (success) setReload((prev) => !prev);
  }
};

const handleBreakStartEndOther = async (otherStaff) => {
  setIsLoading(true);
  const id = otherStaff.id;
  const now = new Date();
  const timeOnly = format(now, 'HH:mm:ss');
  const dateOnly = format(now, 'yyyy-MM-dd');
  let success = false;

  try {
    const getGeoTag = () =>
      new Promise((resolve) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              resolve(`${latitude},${longitude}`);
            },
            () => resolve('Unknown')
          );
        } else {
          resolve('Unknown');
        }
      });

    const geoTag = await getGeoTag();

    const clockInResponse = await fetch('https://api.insightos.co.uk/api/clockin', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });

    if (!clockInResponse.ok) {
      const err = await clockInResponse.json().catch(() => ({}));
      throw new Error(err.message || 'Failed to fetch clock-in records');
    }

    const clockInData = await clockInResponse.json();
    const clockInDataAll = clockInData.data;

    const clockInDataFiltered = clockInDataAll.filter((c) => {
      const clockInDate = parseISO(c.Date);
      const clockInDateFormatted = format(clockInDate, 'yyyy-MM-dd');
      return c.StaffId === id && clockInDateFormatted === dateOnly;
    });

    if (clockInDataFiltered.length > 0 && clockInDataFiltered[0].Break === 1) {
      const breakStart = new Date(`${dateOnly}T${clockInDataFiltered[0].BreakStart}`);
      const breakEnd = now;
      const breakLength = (breakEnd - breakStart) / 60000;

      const putRes = await fetch(`https://api.insightos.co.uk/api/clockin/breakend/${clockInDataFiltered[0].id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          BreakEnd: timeOnly,
          Break: 0,
          StaffBreak: parseFloat(breakLength),
          GeoTag: geoTag,
        }),
      });

      const putJson = await putRes.json().catch(() => ({}));
      if (!putRes.ok) throw new Error(putJson.message || 'Failed to end break for other user');

      console.log(`${otherStaff.Name} ended break with GeoTag: ${geoTag}`);
      success = true;
    } else if (clockInDataFiltered.length > 0) {
      const putRes = await fetch(`https://api.insightos.co.uk/api/clockin/breakstart/${clockInDataFiltered[0].id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          BreakStart: timeOnly,
          Break: 1,
          GeoTag: geoTag,
        }),
      });

      const putJson = await putRes.json().catch(() => ({}));
      if (!putRes.ok) throw new Error(putJson.message || 'Failed to start break for other user');

      console.log(`${otherStaff.Name} started break with GeoTag: ${geoTag}`);
      success = true;
    } else {
      console.log('No clock-in record found for today.');
      setError('No clock-in record found for today.');
    }
  } catch (error) {
    console.error('Error handling break start/end for other user:', error);
    setError(error.message || 'Error handling break for other user');
  } finally {
    setIsLoading(false);
    if (success) setReload((prev) => !prev);
  }
};

const handleClockOutAll = async () => {
  setIsLoading(true); // Start loading
  try {
      const clockInResponse = await fetch('https://api.insightos.co.uk/api/clockoutall', {
          method: 'PUT',
          headers: {
              'Content-Type': 'application/json',
          },
          credentials : 'include',

      });
      const clockInData = await clockInResponse.json();
      if (!clockInResponse.ok) {
          throw new Error(clockInData.message || 'Failed to clock out all staff.');
      }
  console.log('All staff clocked out successfully.');
  // Toggle reload to refresh main list and re-fetch clock ins
  setReload(prev => !prev);
  fetchClockIns(); 
  } catch (error) {
      console.error('Error clocking out all staff:', error);
      setError('Failed to clock out all staff.');
  }
  setIsLoading(false);
};




  // if (clock === true) {
  //   return <ClockInData />;
  // }

  const [query, setQuery] = useState('');

  const filtered = staffList.filter((s) => s.Name.toLowerCase().includes(query.toLowerCase()) || (s.Role || '').toLowerCase().includes(query.toLowerCase()));
  // Early return when loading to simplify JSX and avoid nested ternaries
  if (isLoading) {
    return (
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center py-12">
          <LoadingComponent />
        </div>
      </div>
    );
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between mb-4">
        <div className="flex items-center gap-3">
          <h1 className="text-lg md:text-xl font-semibold text-gray-900 bg-gradient-to-r from-blue-100 to-indigo-100 px-3 py-1 rounded-md shadow-sm">Clock Ins</h1>
          <span className="text-sm text-gray-600 hidden md:inline">Clocked in: <span className="font-medium text-gray-900">{staff.length}</span></span>
        </div>

        <div className="flex items-center gap-2">
          <input
            aria-label="Search staff"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search by name or role"
            data-component="staff-actions"
            data-feature="search-staff"
            className="w-full md:w-64 rounded-md border border-gray-200 bg-white text-gray-900 placeholder-gray-400 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />

          <button
            onClick={handleClockOutAll}
            data-component="staff-actions"
            data-feature="clock-out-all"
            data-time-saved="3"
            className="inline-flex items-center gap-2 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white transition transform duration-150 ease-in-out hover:bg-indigo-700 hover:shadow-md hover:scale-105"
          >
            <ArrowDownOnSquareIcon className="h-4 w-4" />
            Clock Out All
          </button>
        </div>
      </div>

      {error && <div className="mb-4 text-sm text-red-400">{error}</div>}

      {isLoading ? (
        <div className="flex justify-center py-12">
          <LoadingComponent />
        </div>
      ) : (
        <>
          {/* Desktop table */}
          <div className="hidden md:block">
            <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
              <table className="min-w-full table-fixed">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Name</th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Role</th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Clock In</th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Actions</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {filtered.map((s) => {
                    const isCurrent = s.id === currentId;
                    // Use bg-gray-100 as a sensible default highlight (Tailwind doesn't have `bg-100`).
                    // Allow a custom `bg-100` class if present in your Tailwind config, with a gray fallback
                    const rowClass = `${isCurrent ? 'bg-100 bg-purple-200' : ''} hover:bg-gray-50`;
                    return (
                      <tr key={s.id} className={rowClass}>
                          <td className="px-4 py-3 text-sm text-gray-900">{s.Name}</td>
                          <td className="px-4 py-3 text-sm text-gray-600">{s.Role}</td>
                          <td className="px-4 py-3 text-sm text-gray-600">{s.clockInTime || '-'}</td>
                          <td className="px-4 py-3 text-sm text-gray-600">
                            <div className="flex items-center gap-2">
                              {s.id === currentId ? (
                                // Current user: existing full-width buttons and endpoints
                                <>
                                  <button
                                    onClick={() => handleClockInOut(s)}
                                    data-component="staff-actions"
                                    data-feature="toggle-clock-self"
                                    className={`flex items-center gap-2 rounded-md px-3 py-1 text-sm font-medium focus:outline-none transition transform duration-150 ease-in-out ${s.isClockedIn ? 'bg-red-600 hover:bg-red-700 text-white hover:shadow-md hover:scale-105' : 'bg-blue-600 hover:bg-blue-700 text-white hover:shadow-md hover:scale-105'}`}
                                  >
                                    {s.isClockedIn ? <ClockIcon className="h-4 w-4 animate-pulse" /> : <MoonIcon className="h-4 w-4" />}
                                    {s.isClockedIn ? 'Clock Out' : 'Clock In'}
                                  </button>

                                  <button
                                    onClick={() => handleBreakStartEnd(s)}
                                    data-component="staff-actions"
                                    data-feature="toggle-break-self"
                                    className={`flex items-center gap-2 rounded-md px-3 py-1 text-sm font-medium focus:outline-none transition transform duration-150 ease-in-out ${s.isOnBreak ? 'bg-green-600 hover:bg-green-700 text-white hover:shadow-md hover:scale-105' : 'bg-orange-500 hover:bg-orange-600 text-white hover:shadow-md hover:scale-105'}`}
                                  >
                                    {s.isOnBreak ? <SunIcon className="h-4 w-4" /> : <MoonIcon className="h-4 w-4" />}
                                    {s.isOnBreak ? 'Back' : 'Break'}
                                  </button>
                                </>
                              ) : (
                                // Other users: circular icon buttons, different colors, and different endpoints
                                <>
                                  <button
                                    onClick={() => handleClockInOutOther(s)}
                                    title="Toggle Clock"
                                    data-component="staff-actions"
                                    data-feature="toggle-clock-other"
                                    className={`flex items-center justify-center h-9 w-9 rounded-full focus:outline-none transition transform duration-150 ease-in-out ${s.isClockedIn ? 'bg-pink-600 hover:bg-pink-700 text-white hover:shadow-md hover:scale-105' : 'bg-indigo-500 hover:bg-indigo-600 text-white hover:shadow-md hover:scale-105'}`}
                                  >
                                    {s.isClockedIn ? <ClockIcon className="h-4 w-4" /> : <MoonIcon className="h-4 w-4" />}
                                  </button>

                                  <button
                                    onClick={() => handleBreakStartEndOther(s)}
                                    title="Toggle Break"
                                    data-component="staff-actions"
                                    data-feature="toggle-break-other"
                                    className={`flex items-center justify-center h-9 w-9 rounded-full focus:outline-none transition transform duration-150 ease-in-out ${s.isOnBreak ? 'bg-lime-600 hover:bg-lime-700 text-white hover:shadow-md hover:scale-105' : 'bg-yellow-400 hover:bg-yellow-500 text-white hover:shadow-md hover:scale-105'}`}
                                  >
                                    {s.isOnBreak ? <SunIcon className="h-4 w-4" /> : <MoonIcon className="h-4 w-4" />}
                                  </button>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobile cards */}
          <div className="grid grid-cols-1 gap-3 md:hidden">
            {filtered.map((s) => (
              <div key={s.id} className={`rounded-lg border border-gray-200 ${s.id === currentId ? 'bg-100 bg-purple-200' : 'bg-white'} p-4`}>
                <div className="flex items-start justify-between">
                  <div>
                    <div className="text-sm font-semibold text-gray-900">{s.Name}</div>
                    <div className="text-xs text-gray-600">{s.Role}</div>
                    <div className="mt-2 text-xs text-gray-600">Clock In: <span className="font-medium text-gray-900">{s.clockInTime || '-'}</span></div>
                  </div>
                  <div className="flex flex-col items-end gap-2">
                    {s.id === currentId ? (
                      <>
                        <button
                          onClick={() => handleClockInOut(s)}
                          data-component="staff-actions"
                          data-feature="toggle-clock-self"
                          className={`flex items-center gap-2 rounded-md px-3 py-1 text-sm font-medium transition transform duration-150 ease-in-out ${s.isClockedIn ? 'bg-red-600 hover:bg-red-700 text-white hover:shadow-md hover:scale-105' : 'bg-blue-600 hover:bg-blue-700 text-white hover:shadow-md hover:scale-105'}`}
                        >
                          {s.isClockedIn ? <ClockIcon className="h-4 w-4" /> : <MoonIcon className="h-4 w-4" />}
                          {s.isClockedIn ? 'Out' : 'In'}
                        </button>
                        <button
                          onClick={() => handleBreakStartEnd(s)}
                          data-component="staff-actions"
                          data-feature="toggle-break-self"
                          className={`flex items-center gap-2 rounded-md px-3 py-1 text-sm font-medium transition transform duration-150 ease-in-out ${s.isOnBreak ? 'bg-green-600 hover:bg-green-700 text-white hover:shadow-md hover:scale-105' : 'bg-orange-500 hover:bg-orange-600 text-white hover:shadow-md hover:scale-105'}`}
                        >
                          {s.isOnBreak ? <SunIcon className="h-4 w-4" /> : <MoonIcon className="h-4 w-4" />}
                          {s.isOnBreak ? 'Back' : 'Break'}
                        </button>
                      </>
                    ) : (
                      <div className="flex flex-col items-end gap-2">
                        <button
                          onClick={() => handleClockInOutOther(s)}
                          title="Toggle Clock"
                          data-component="staff-actions"
                          data-feature="toggle-clock-other"
                          className={`flex items-center justify-center h-9 w-9 rounded-full focus:outline-none transition transform duration-150 ease-in-out ${s.isClockedIn ? 'bg-pink-600 hover:bg-pink-700 text-white hover:shadow-md hover:scale-105' : 'bg-indigo-500 hover:bg-indigo-600 text-white hover:shadow-md hover:scale-105'}`}
                        >
                          {s.isClockedIn ? <ClockIcon className="h-4 w-4" /> : <MoonIcon className="h-4 w-4" />}
                        </button>
                        <button
                          onClick={() => handleBreakStartEndOther(s)}
                          title="Toggle Break"
                          data-component="staff-actions"
                          data-feature="toggle-break-other"
                          className={`flex items-center justify-center h-9 w-9 rounded-full focus:outline-none transition transform duration-150 ease-in-out ${s.isOnBreak ? 'bg-lime-600 hover:bg-lime-700 text-white hover:shadow-md hover:scale-105' : 'bg-yellow-400 hover:bg-yellow-500 text-white hover:shadow-md hover:scale-105'}`}
                        >
                          {s.isOnBreak ? <SunIcon className="h-4 w-4" /> : <MoonIcon className="h-4 w-4" />}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

